export default {"src":"/_next/static/media/watch-cracked.f363ad9b.svg","height":73,"width":62};